<template>
  <div class="store_blocks">
    <div
      v-html="getStoreInfoByStore($AllDivisions[locality.division_id]?.stores[0]?.object_id || null)"
      class="selected_store"/>
    <template
      v-for="(storeId, index) in ($StoreRelations[$AllDivisions[locality.division_id]?.stores[0]?.object_id] || [])">
      <div
        v-if="$AllDivisions[locality.division_id]"
        v-html="getStoreInfoByStore(storeId, index === 0 ? $AllDivisions[locality.division_id]?.stores[0]?.object_id : $StoreRelations[$AllDivisions[locality.division_id]?.stores[0]?.object_id][(index-1)])"/>
    </template>
    <div v-if="inRunnersStores && +locality.city_id === 1 && Object.keys(inRunnersStores[3]).length"
         class="extra_store_div">
      <p v-for="(storeData, storeId) in inRunnersStores[3]">{{ storeData.title }}:
        <strong>{{ storeData.qty }}</strong></p>
    </div>
  </div>
</template>
<script>

import moment from 'moment';

export default {
  props: ['updatedStoreData', 'drug', 'storeData', 'inRunnersStores', 'locality'],
  computed: {
    $StoreRelations() {
      return this.$store.getters['platform/storeRelations']
    },
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  methods: {
    getRelatedRequestsByStoreId(storeId, exclude, index = 0, sortedStores = []) {
      const stores = Object.values(this.$AllStores).filter((s) => s.parent_id === +storeId)
      stores.forEach((s) => {
        if (exclude != s.id) {
          sortedStores = this.getRelatedRequestsByStoreId(s.id, exclude, 1, sortedStores)
        }
      })
      if (index) {
        sortedStores.push(storeId)
      }
      return sortedStores
    },
    getStoreInfoByStore(storeId, exclude = null, numberOnly = false) {
      if (!storeId) {
        storeId = 3;
      }
      if (!storeId) return;
      if (!this.updatedStoreData?.clearedStore) return;
      const stores = this.getRelatedRequestsByStoreId(storeId, exclude)
      // console.log(storeId, exclude, stores)
      let qty = (this.updatedStoreData.clearedStore[storeId] || 0) - (this.updatedStoreData.storesRequests[storeId] || 0)
      // console.log(stores, qty, storeId, this.updatedStoreData.clearedStore[storeId]);
      stores.forEach((sId) => {
        qty -= +(this.updatedStoreData.storesRequests[sId] || 0)
      })

      let transitQty = 0
      let transitDate = moment()
      if (this.storeData.transitDetails[this.drug.id] && this.storeData.transitDetails[this.drug.id][storeId] && this.storeData.transitDetails[this.drug.id][storeId].details_in) {
        this.storeData.transitDetails[this.drug.id][storeId].details_in.forEach((t) => {
          transitQty += t.qty
          if (transitDate < moment(t.date)) {
            transitDate = moment(t.date)
          }
        })
      }
      let inStore = this.updatedStoreData.inStore && this.updatedStoreData.inStore[storeId] || 0
      inStore -= Object.keys(this.storeData.requests[this.drug.id] && this.storeData.requests[this.drug.id][storeId] || {}).reduce((acc, reserveType) => {
        acc += +this.storeData.requests[this.drug.id][storeId][reserveType].qty
        return acc
      }, 0)
      if (numberOnly) return qty;
      return (this.$AllStores[storeId] && this.$AllStores[storeId].short_title || `Не найден (${storeId})`) + ': <strong>' + (qty) + '</strong>'
        + (transitQty ? ` из них на складе <strong>${inStore}</strong> в дороге <strong>${transitQty}</strong> (поступление ${transitDate.format('DD.MM')})` : '')
    },
  }
}

</script>

<style scoped>
.store_blocks div.extra_store_div {
  border: 4px solid #5bbfde;
  margin-left: auto;
}

.store_blocks {
  display: flex;
  flex-wrap: wrap;
}

.store_blocks .selected_store {
  border: 3px solid gray;
}

.store_blocks div {
  padding: 0 5px;
  border: 2px solid lightgray;
  margin-right: 3px;
}
</style>
